import { isNil } from 'lodash';
import { Field } from '@shared/data/entity/fields/Field';
import { isTagComponent } from '@shared/scenes/workflows/utils';
import { API } from '@shared/types/api';
import { TagComponentForm } from './TagComponentForm';

export interface SingleComponentFormProps {
  field: Field | null;
  workflowTemplate: API.WorkflowTemplateFragment;
  fieldName: string;
  anchorName: string;
  loading: boolean;
  onClose(): void;
  onUpdateField(fieldName: string, value: any): void;
}

export function SingleComponentForm({
  field,
  fieldName,
  workflowTemplate,
  anchorName,
  onClose,
  onUpdateField,
  loading: isLoading,
}: SingleComponentFormProps) {
  const relatedComponent = workflowTemplate.components.find(c => c.id === fieldName);

  if (isNil(relatedComponent)) {
    return null;
  }

  if (isTagComponent(relatedComponent)) {
    return (
      <TagComponentForm
        onUpdateField={onUpdateField}
        field={field}
        fieldName={fieldName}
        anchorName={anchorName}
        component={relatedComponent}
        onClose={onClose}
        loading={isLoading}
        workflowTemplate={workflowTemplate}
      />
    );
  }

  return null;
}
